/**
 * @lodex-pro/web-admin/features/operators/platform-operator-search — the catalog operator
 * typeahead. Moved here from the operator-registrations hooks when OPP PR 13a removed the
 * registration queue; the Express customer dialog uses it.
 */
import { useApiQuery, useApiOpts } from '@lodex-pro/web-shared';

export interface PlatformOperatorSearchRow {
  readonly id: string;
  readonly name: string;
  readonly displayName: string | null;
  readonly abbreviation: string | null;
  readonly state: string | null;
}

// Reuses the existing GET /v1/platform/operators?q= endpoint (Phase 25 / DEC-114).
// The `enabled` gate keeps the query dormant until the admin types at least one
// character; staleTime prevents thrashing while the admin is deciding.
export function usePlatformOperatorSearch(
  query: string,
): ReturnType<typeof useApiQuery<{ operators: readonly PlatformOperatorSearchRow[] }>> {
  const opts = useApiOpts();
  return useApiQuery<{ operators: readonly PlatformOperatorSearchRow[] }>(
    opts,
    `/v1/platform/operators?q=${encodeURIComponent(query)}`,
    {
      queryKey: ['platform-operators-search', query],
      enabled: query.trim().length > 0,
      staleTime: 60_000,
    },
  );
}
